import brands from './brands'
import packaging from './packaging'
import certifications from './certifications'
import productLines from './productLines'
import countries from './countries'
import markets from './markets'
import receivers from './receivers'
import farms from './farms'
import varieties from './varieties'

// retailer endpoints
import retailers from './retailers'
import certificationRequirements from './certificationRequirements'
import specifications from './specifications'
import farmPreferences from './farmPreferences'
import specificationVarietyPreferences from './specificationVarietyPreferences'
import blockedSuppliers from './blockedSuppliers'
import regions from './regions'

export default function dueDiligence(instance) {
	return {
		brands: brands(instance),
		packaging: packaging(instance),
		certifications: certifications(instance),
		productLines: productLines(instance),
		countries: countries(instance),
		markets: markets(instance),
		farms: farms(instance),
		receivers: receivers(instance),
		varieties: varieties(instance),
		retailers: retailers(instance),
		// retailer related
		certificationRequirements: certificationRequirements(instance),
		farmPreferences: farmPreferences(instance),
		specifications: specifications(instance),
		specificationVarietyPreferences: specificationVarietyPreferences(instance),
		blockedSuppliers: blockedSuppliers(instance),
		//
		regions: regions(instance)
	}
}
